import * as colors from '../../../common/colorConstants';
import styled from 'styled-components/macro';
import { lowHeightScreens, mediumScreens, smallScreens } from '../../../common/fontElements';

const Container = styled.div`
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  height: 100%;
  overflow: scroll;
  position: relative;
`;

const Icon = styled.img`
  padding-bottom: 20px;
`;

const SubMessage = styled.p`
  margin-top: 30px;
`;

const TitleText = styled.p`
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: 0px;
  text-align: center;
  color: ${colors.black1};
  margin: 0px;
  @media screen and (max-width: ${mediumScreens}) {
    font-size: 13px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 12px;
  }
`;

const PageHeader = styled.div`
  padding: 30px 0px 20px;
  border-bottom: 1px solid #d8e8ef;
  text-align: center;
`;

export { Container, Icon, SubMessage, TitleText, PageHeader };
